import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button, Popconfirm, Flex, Modal, message } from "antd";
import { DeleteOutlined, ExclamationCircleFilled } from "@ant-design/icons";
//components
//actions
import { updateStaff } from "../../../../store/staff/staff.action";
//selector

//function
//str
const { confirm } = Modal;
const BranchStaffListingInActive = ({ item, loading, setLoading }) => {
  // -------------------------- VAR ----------------------------
  const fullName = item?.fullName;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX -------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ---------------------
  const showConfirm = () => {
    confirm({
      title: ` Do you want to deactive "${fullName}"?`,
      icon: <ExclamationCircleFilled />,
      // content: "Giao dịch sẽ bị xoá khỏi danh sách thanh toán",
      onOk() {
        handleOk(item);
      },
      onCancel() {
        handleCancel();
      },
      okButtonProps: {
        className: "ok-btn-style",
        danger: true,
      },
      cancelButtonProps: {
        className: "cancel-btn-style",
      },
      okText: "Yes",
      cancelText: "Cancel",
    });
  };

  const handleCancel = () => {
    console.log("cancelled");
  };
  const handleOk = (staff) => {
    const active = staff?.active || false;

    const update = {
      active: !active,
    };

    if (staff) {
      setLoading(true);
      dispatch(
        updateStaff({ staff, update }, (response) => {
          if (response.status === 200) {
            message.success(`The User was ${active ? "Deactived" : "Active"}`);
          } else {
            message.error(response.data || "Error! Please try again");
          }
          setLoading(false);
        })
      );
    }
  };

  // -------------------------- EFFECT ------------------------
  // -------------------------- RENDER ------------------------
  // -------------------------- MAIN ---------------------------
  return (
    <Button
      loading={loading}
      className="width-100px"
      style={{ backgroundColor: "red", border: 0, color: "white" }}
      type="default"
      onClick={showConfirm}
    >
      Deactive
    </Button>
  );
};
export default BranchStaffListingInActive;
